import GalleryItem from "../GalleryItem";
import ImageItemModal from "./ImageItemModal";
import objectToFormData from "object-to-formdata";
import CookieHelper from "base/CookieHelper";
import Ajax from "base/Ajax";

class GalleryItemImage extends GalleryItem {

    getImageUrl(size = '2' /* Thumbnail */) {
        return this.data.versions[size].url
    }

    getElementClasses() {
        return 'admin-gallery__item--image '
    }

    getModal(settings = {}) {
        return new ImageItemModal(this, settings);
    }

    save() {
        let data = $.extend(true, {}, this.data);
        delete(data.versions);
        if (this.imageChanged) {
            return new Promise((resolve, reject) => {

                data = objectToFormData(data);
                data.append("image", this.image, "image.jpeg");
                data.append("csrf", CookieHelper.get('csrf'));
                let request = new XMLHttpRequest();
                request.addEventListener("load", function () {
                    let data;

                    try {
                        data = JSON.parse(request.responseText);
                    } catch (e) {
                        console.log(e);
                        data = {
                            success: false,
                            message: "Connection error"
                        }
                    }
                    if (request.status === 200 && data.success === true) {
                        resolve(data.data);
                    } else {
                        let error = new Error(data.message);
                        error.data = data;
                        reject(error)
                    }
                });

                request.open("POST", this.data.href + "/replace", true);
                request.send(data);
            })
        } else {
            return this.changed ? Ajax.post(null, this.data.href, data) : Promise.resolve(this.data);
        }
    }

}

export {GalleryItemImage as default};
